import React, { useState } from 'react';
import { useAttendance } from '../context/AttendanceContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUsers, FiEdit2, FiTrash2, FiCheck, FiX } = FiIcons;

const StudentList = () => {
  const { students, removeStudent, editStudent } = useAttendance();
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');

  const startEdit = (student) => {
    setEditingId(student.id);
    setEditName(student.name);
  };

  const saveEdit = () => {
    if (editName.trim()) {
      editStudent(editingId, editName);
    }
    setEditingId(null);
    setEditName('');
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditName('');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      saveEdit();
    } else if (e.key === 'Escape') {
      cancelEdit();
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
        <SafeIcon icon={FiUsers} className="w-5 h-5 mr-2 text-indigo-600" />
        Students ({students.length})
      </h2>

      {students.length === 0 ? (
        <p className="text-gray-500 text-center py-4">No students added yet</p>
      ) : (
        <div className="space-y-2 max-h-96 overflow-y-auto">
          {students.map((student) => (
            <div
              key={student.id}
              className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
            >
              {editingId === student.id ? (
                <div className="flex items-center space-x-2 flex-1">
                  <input
                    type="text"
                    value={editName}
                    onChange={(e) => setEditName(e.target.value)}
                    onKeyDown={handleKeyPress}
                    className="flex-1 px-2 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
                    autoFocus
                  />
                  <button
                    onClick={saveEdit}
                    className="p-1 text-green-600 hover:text-green-700"
                  >
                    <SafeIcon icon={FiCheck} className="w-4 h-4" />
                  </button>
                  <button
                    onClick={cancelEdit}
                    className="p-1 text-gray-500 hover:text-gray-700"
                  >
                    <SafeIcon icon={FiX} className="w-4 h-4" />
                  </button>
                </div>
              ) : (
                <>
                  <span className="text-gray-900 font-medium">{student.name}</span>
                  <div className="flex items-center space-x-1">
                    <button
                      onClick={() => startEdit(student)}
                      className="p-1 text-gray-500 hover:text-indigo-600 transition-colors"
                    >
                      <SafeIcon icon={FiEdit2} className="w-4 h-4" />
                    </button>
                    <button
                      onClick={() => removeStudent(student.id)}
                      className="p-1 text-gray-500 hover:text-red-600 transition-colors"
                    >
                      <SafeIcon icon={FiTrash2} className="w-4 h-4" />
                    </button>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StudentList;